import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=a4362e76"
import script from "./BannerManage.vue?vue&type=script&lang=js"
export * from "./BannerManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports